<template>
    <div class="section" dir="rtl">
        <div class="container">
            <div class="breadcrumb mb-10 text-bold" id="biography" > {{  $t('header.supremeAuthority.title') }} > {{ $t('header.supremeAuthority.legislative.title') }}</div>
        </div>
    </div>
    <div class="container mt-5 text-center mb-5" dir="rtl">
        <div class="title">
            {{ $t('header.supremeAuthority.legislative.titlePage') }}
        </div>
        <div class="mot_president">
            <p>
                {{ $t('header.supremeAuthority.legislative.content_1.text_1') }}
            </p>
            <a :href="'pdf/AConsti.pdf'" target="_blank" class="btn btn-danger">
                {{ $t('header.supremeAuthority.legislative.content_1.title_pdf') }}
                <img :src="'images/icons/pdf.png'" alt="">
            </a>
        </div>
        <div class="mot_president mt-4 mb-4">
            <p>
                {{ $t('header.supremeAuthority.legislative.content_2.title') }}
            </p>
            <ul style="text-align: right">
                <li>
                    {{ $t('header.supremeAuthority.legislative.content_2.text_1') }}
                </li>
                <li>
                    {{ $t('header.supremeAuthority.legislative.content_2.text_2') }}
                </li>
                <li>
                    {{ $t('header.supremeAuthority.legislative.content_2.text_3') }}
                </li>
                <li>
                    {{ $t('header.supremeAuthority.legislative.content_2.text_4') }}
                </li>
                <li>
                    {{ $t('header.supremeAuthority.legislative.content_2.text_5') }}
                </li>
                <li>
                    {{ $t('header.supremeAuthority.legislative.content_2.text_6') }}
                </li>
                <li>
                    {{ $t('header.supremeAuthority.legislative.content_2.text_7') }}
                </li>
                <li>
                    {{ $t('header.supremeAuthority.legislative.content_2.text_8') }}
                </li>
                <li>
                    {{ $t('header.supremeAuthority.legislative.content_2.text_9') }}
                </li>
                <li>
                    {{ $t('header.supremeAuthority.legislative.content_2.text_10') }}
                </li>
            </ul>
            <a :href="'pdf/Cadrelegal.pdf'" target="_blank" class="btn btn-danger">
                {{ $t('header.supremeAuthority.legislative.content_2.title_pdf') }}
                <img :src="'images/icons/pdf.png'" alt="">
            </a>
        </div>
        <div class="mot_president">
            <p>
                {{ $t('header.supremeAuthority.legislative.content_3.text_1') }}
            </p>
            <a :href="'pdf/قانون-السلطة-العليا-للشفافية.pdf'" target="_blank" class="btn btn-danger">
                {{ $t('header.supremeAuthority.legislative.content_3.title_pdf') }}
                <img :src="'images/icons/pdf.png'" alt="">
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "legislative"
    }
</script>

<style scoped>
    ul.no-bullets {
        list-style-type: none;
        margin: 0;
        padding: 0;
    }
    .mot_president{
        color: rgba(50, 54, 57, 0.83);
    }
    .nav-link{
        color: rgba(80, 84, 87, 0.8) !important;
    }
    .active{
        color: rgba(28, 28, 28, 0.96)!important;
    }
    .section {
        display: flex;
        align-items: center;
        font-size: var(--xs-font-size);
        font-weight: bold;
        background: var(--secondary-background-color);
        padding: calc(7/16 * var(--default-size-unit)) calc((100vw - 1920px)/2 +  var(--body-padding));
        border-top: var(--input-border);
        border-bottom: var(--input-border);
        font-family: Cairo,sans-serif;
    }
    .breadcrumb{
        text-decoration: none!important;
        margin: 0;
        color: #37414D;
        font-family: Cairo,sans-serif!important;
    }
    .title {
        width: 100%;
        display: flex;
        align-items: center;
        font-size: var(--l-font-size);
        font-weight: 700;
    }
    .title::before {
        content: ' ';
        display: block;
        -webkit-margin-end: var(--default-size-unit);
        margin-inline-end: var(--default-size-unit);
        width: calc(35/16 * var(--default-size-unit));
        height: calc(8/16 * var(--default-size-unit));
        background: var(--primary-text-color);
        min-width: calc(35/16 * var(--default-size-unit));
    }
    .back-gray{
        background-color: #E7E9EB;
        padding: 15px 15px;
    }
    .back-gray p{
        line-height: 200%;
    }
</style>